import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { PermissionsService } from 'src/app/service/permissions/permissions.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styles: [`
        .ia-button {
            font-weight: 700;
            letter-spacing: .5px;
            animation: ia-glow 1.8s ease-in-out infinite;
        }
        @keyframes ia-glow {
            0%, 100% { box-shadow: 0 0 4px rgba(124, 58, 237, .5), 0 0 8px rgba(124, 58, 237, .35); }
            50%      { box-shadow: 0 0 10px rgba(124, 58, 237, .9), 0 0 20px rgba(124, 58, 237, .6); }
        }
    `]
})
export class AppTopbarComponent implements OnInit {

    @ViewChild('menubutton') menuButton!: ElementRef;

    canVerIA = false;
    iaItems: MenuItem[] = [];

    constructor(
        public layoutService: LayoutService,
        private permService: PermissionsService,
        private router: Router
    ) { }

    ngOnInit() {
        this.iaItems = [
            {
                label: 'Claudera',
                icon: 'pi pi-external-link',
                command: () => this.abrirClaudera()
            },
            {
                label: 'Prompt de documentos',
                icon: 'pi pi-file-edit',
                command: () => this.router.navigate(['/ia/prompts'])
            }
        ];

        this.permService.getMyViewPermissions().subscribe({
            next: (keys: any) => {
                const set = Array.isArray(keys)
                    ? new Set(keys)
                    : (keys && typeof keys === 'object' ? new Set(Object.keys(keys)) : new Set());
                this.canVerIA = set.has('ia.view');
            },
            error: () => { this.canVerIA = false; }
        });
    }

    abrirClaudera() {
        window.open(environment.clauderaUrl, '_blank', 'noopener,noreferrer');
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }
    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

}
